import { render, staticRenderFns } from "./EntitiesList.vue?vue&type=template&id=62321831&"
import script from "./EntitiesList.vue?vue&type=script&lang=js&"
export * from "./EntitiesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports